import React from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {MenuItemVariants} from "./records/MenuItemVariants";
import {DishesCategories} from "./records/DishesCategories";
import {Additions} from "./records/Additions";
import {WelcomeSlogans} from "./records/WelcomeSlogans";
import {CategoriesSkeleton} from "../dishes-categories/CategoriesSkeleton";

export const TranslationsList = () => {
    const {t} = useTranslation();
    const {
        chosenGroup,
        dishesCategories,
        variants,
        additions
    } = useSelector(state => state.translations.view);

    const renderRecords = () => {
        switch (chosenGroup?.value) {
            case 'menuItemsVariants':
                if (!variants) return <CategoriesSkeleton/>
                return <MenuItemVariants/>;
            case 'categoriesMenuItems':
                if (!dishesCategories) return <CategoriesSkeleton/>
                return <DishesCategories/>;
            case 'additions':
                if (!additions) return <CategoriesSkeleton/>
                return <Additions/>;
            case 'welcomeSlogan':
                return <WelcomeSlogans/>;
            default:
                return (<p className={'text-center'}>{t('noRecordsFound')}</p>);
        }
    }

    return (
        <div className={'scrollable-wrapper'}>
            {renderRecords()}
        </div>
    );
}